// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"yw","tile":"yx","imageWrapper":"yy","img":"yz","header":"yA","caption":"yB"};